export default __webpack_public_path__ + "static/media/bubbleBackground.86658bcf.png";